import { RootState } from 'types';
import { initialState } from '.';
import { createSelector } from 'reselect';

const selectRootStore = (state: RootState) => state.root || initialState;

export const selectTheme = createSelector(selectRootStore, (root) => {
  return root.theme;
});

export const selectPinned = createSelector(selectRootStore, (root) => {
  return root.pinned;
});

export const selectHeader = createSelector(selectRootStore, (root) => {
  return root.headerHolder;
});
